export const TARGET_OPTIONS = [
  { text: "Nhân viên", value: "employee" },
  { text: "Đội nhóm", value: "team" },
];
